import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { getActiveUrl, getQueryParams, RouterState } from '~core/store';
import { UrlUtils } from '~app/modules/generic/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class ProductsListUrlService {
  private activeUrl: string;
  private searchTerm: string;
  private _subCategoryId: string;

  set subCategoryId(value: string) {
    this._subCategoryId = value;
  }

  get subCategoryId(): string {
    return this._subCategoryId;
  }


  constructor(private store: Store<RouterState>) {
    this.store.pipe(select(getActiveUrl))
      .subscribe(url => this.activeUrl = url);

    this.store.pipe(select(getQueryParams))
      .subscribe(params => {
        if (!params) {
          return;
        }
        this.searchTerm = params.q;
      });
  }

  isProductListPage(): boolean {
    return UrlUtils.isProductListPage(this.activeUrl);
  }

  isCategoryPage(): boolean {
    return UrlUtils.isCategoryPage(this.activeUrl);
  }

  isCatalogPage(): boolean {
    return UrlUtils.isCatalogPage(this.activeUrl);
  }

  isSearchPage(): boolean {
    return UrlUtils.isSearchPage(this.activeUrl);
  }

  isCustomPLPPage(): boolean {
    return UrlUtils.isCustomPLPPage(this.activeUrl);
  }

  isBrandPLPPage(): boolean {
    return UrlUtils.isBrandPlpPage(this.activeUrl);
  }

  getCategory(): string {
    return UrlUtils.getCategoryFromUrl(this.activeUrl);
  }

  getBrandSlug(): string {
    return UrlUtils.getSlugFromUrl(this.activeUrl);
  }

  getCustomPlpSlug(): string {
    return UrlUtils.getSlugFromUrl(this.activeUrl);
  }

  getSearchTerm(): string {
    return this.searchTerm;
  }
}
